import { useQuery } from "@tanstack/react-query";

import { apiResolverApi } from "../../apiResolverApi";
import { bootstrapQueryKeys } from "./bootstrapQueryKeys";

export function useRoutesByBrand(
  params: Parameters<typeof apiResolverApi.findRoutes>[0],
) {
  return useQuery({
    queryKey: bootstrapQueryKeys.listByBrand(params),
    queryFn: async () => {
      return await apiResolverApi.findRoutes(params);
    },
  });
}
